/**
 * Σπάει κυκλική εξάρτηση: store <-> motion-components.
 * Η εφαρμογή ορίζει τα getters· τα motion-components τα διαβάζουν.
 */
let getTableStore: () => any = () => undefined;
let getMotionUIStore: () => any = () => undefined;

export function setTableStoreGetter(fn: () => any) {
  getTableStore = fn;
}

export function getTableStoreFromRef() {
  return getTableStore();
}

export function setMotionUIStoreGetter(fn: () => any) {
  getMotionUIStore = fn;
}

export function getMotionUIStoreFromRef() {
  return getMotionUIStore();
}
